import React from 'react';

const Device = () => {
  return (
    <div className="device-container">
      <div className="device">
        <div className="device-signal">
          <div className="signal-wave"></div>
          <div className="signal-wave"></div>
          <div className="signal-wave"></div>
        </div>
        <div className="device-screen"></div>
        <div className="device-logo">AEROFI</div>
        <div className="device-button"></div>
      </div>
    </div>
  );
};

export default Device;